import type { MouseEvent, ReactNode } from "react";

export type AppUser = {
  firstName?: string;
  lastName?: string;
  email?: string;
  username?: string;
  role?: string;
  accountId?: string;
};

export type AppSidebarSubItem = {
  href: string;
  icon: ReactNode;
  label: string;
  exactActive?: boolean;
  external?: boolean;
};

export type AppSidebarItem = {
  href: string;
  icon: ReactNode;
  label: string;
  subItems?: AppSidebarSubItem[];
  excludeActivePathPrefixes?: string[];
  onClick?: () => void;
};

export type AppSidebarGroup = {
  group: string;
  collapsible?: boolean;
  defaultOpen?: boolean;
  pinned?: boolean;
  items: AppSidebarItem[];
};

export type AppBreadcrumbItem = {
  label: string;
  icon?: ReactNode;
  href?: string;
};

export type AppLinkRenderProps = {
  href: string;
  className?: string;
  children: ReactNode;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
};

export const DEFAULT_ROLE_LABELS: Record<string, string> = {
  super_admin: "Super admin",
  admin: "Admin",
  "3d_designer": "3D designer",
  moderator: "Moderator",
  user: "User",
  licensed: "Licensed",
};
